"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _visuallyHidden = require("@react-aria/visually-hidden");

var _iconClose = _interopRequireDefault(require("../../../shared/icons/icon-close.svg"));

var _iconHamburger = _interopRequireDefault(require("../../../shared/icons/icon-hamburger.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MobileHamburgerButton = function MobileHamburgerButtonComponent(_ref) {
  var drawerIsOpen = _ref.drawerIsOpen,
      toggleDrawerOpen = _ref.toggleDrawerOpen;
  var triggerClass = (0, _classnames["default"])({
    'site-header__drawer-trigger': true,
    'site-header__drawer-trigger--open': drawerIsOpen
  });
  var triggerText = drawerIsOpen ? 'close navigation drawer' : 'open navigation drawer';

  var handleEscape = function handleEscape(_ref2) {
    var key = _ref2.key;

    if (key === 'Escape' && drawerIsOpen) {
      toggleDrawerOpen();
    }
  };

  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: triggerClass,
    onClick: toggleDrawerOpen,
    onKeyDown: handleEscape
  }, /*#__PURE__*/_react["default"].createElement(_visuallyHidden.VisuallyHidden, null, triggerText), drawerIsOpen ? /*#__PURE__*/_react["default"].createElement(_iconClose["default"], {
    className: "site-header__drawer-icon site-header__drawer-icon--close"
  }) : /*#__PURE__*/_react["default"].createElement(_iconHamburger["default"], {
    className: "site-header__drawer-icon site-header__drawer-icon--hamburger"
  }));
};

MobileHamburgerButton.propTypes = {
  drawerIsOpen: _propTypes["default"].bool.isRequired,
  toggleDrawerOpen: _propTypes["default"].func.isRequired
};
var _default = MobileHamburgerButton;
exports["default"] = _default;